var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78008 22.4267H12.3411C12.4333 22.4267 12.5081 22.5014 12.5081 22.5937V22.6011C12.5081 22.9451 12.7872 23.2242 13.1311 23.2242H16.3711C16.715 23.2242 16.9942 22.9451 16.9942 22.6011V22.5937C16.9942 22.5014 17.069 22.4267 17.1612 22.4267H25.7222C26.0661 22.4267 26.3452 22.7058 26.3452 23.0497V24.0217C26.3452 24.3657 26.0661 24.6448 25.7222 24.6448H3.78008C3.43614 24.6448 3.157 24.3657 3.157 24.0217V23.0497C3.157 22.7058 3.43614 22.4267 3.78008 22.4267ZM5.0985 23.5407C5.0985 23.7102 5.23557 23.8497 5.40752 23.8497H6.74089C6.91039 23.8497 7.04993 23.7127 7.04993 23.5407V23.5332C7.04993 23.3637 6.91286 23.2242 6.74089 23.2242H5.40752C5.23804 23.2242 5.0985 23.3613 5.0985 23.5332V23.5407Z",
    fill: "#5686E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18074 6H24.172C25.3733 6 26.3527 6.97947 26.3527 8.18075V19.3487C26.3527 20.55 25.3733 21.5294 24.172 21.5294H5.18074C3.97946 21.5294 2.99999 20.55 2.99999 19.3487V8.18075C2.99999 6.97947 3.97946 6 5.18074 6ZM4.86921 19.3487C4.86921 19.5207 5.00878 19.6602 5.18074 19.6602H24.172C24.3439 19.6602 24.4835 19.5207 24.4835 19.3487V8.18075C24.4835 8.00878 24.3439 7.86922 24.172 7.86922H5.18074C5.00878 7.86922 4.86921 8.00878 4.86921 8.18075V19.3487Z",
    fill: "#5686E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0757 14.2747L13.6164 13.3893L15.1617 16.6083L15.458 15.4329L16.698 16.4499L17.2209 15.8123L15.9809 14.7953L17.0757 14.2747Z",
    fill: "#5686E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.09276,
    height: 4.09276,
    fill: "white",
    transform: "translate(13.0045 13.683) rotate(-25.6432)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktop-icon.f2bd640eaa62bc41f60d9c7fd972216f.svg";
export { ForwardRef as ReactComponent };